export const setShowSidebar = showSidebar => ({
  type: "APP_SET_SIDEBAR",
  showSidebar
});
